import React, { useEffect as uEffect, useState as uState } from 'react'

// import Capsule from '../../threeD/capsule'
// import DiscountImg from '../../../assets/images/capsule3.jpg'
// import DiscountImg1 from '../../../assets/images/capsule4.png'
import Product from '../../Cards/productCard'



export default function medicinesCarousel() {

    const [search,setSearch]=uState("")
    const [prod, setProd] = uState([])
    const [prodType, setProdType] = uState([])

    const loadData = async () => {
        let response = await fetch('http://localhost:8000/cart/showCart', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        response = await response.json()
        setProd(response[0])
        setProdType(response[1])
    }

    uEffect(() => {
        loadData()
    }, [])

    

    // let displayedHeadings = {};

    const handleDiscountImage = ()=> {
        document.getElementById('discount').style.display = 'none'
    }

    return (
        <>

            <div style={{ marginTop: '10px' }}>
                <div className="navbar">
                    <div className="d-flex flex-grow-1 ">
                        <div className="mr-2 my-auto w-100 d-inline-block order-1 " style={{ border: '0.1px solid black ' }}>
                                <input  type="search" onFocus={handleDiscountImage} value={search} onChange={(e) => { setSearch(e.target.value) }} className="form-control searchbar border border-right-0" placeholder="Search..." />
                        </div>
                    </div>
                </div>
                <section id='discount' className="discount_section ">
                    <div className="container-fluid ">
                        <div className="row ">
                            <div className="col-lg-3 col-md-5 offset-md-2">
                                <div className="detail-box">
                                    <h2>
                                        You get any medicine on
                                        <span>
                                            10% discount
                                        </span>
                                    </h2>
                                    <p>
                                        It is a long established fact that a reader will be distracted by
                                    </p>
                                    <div>
                                        <a href="#seeMore">
                                            Buy Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-5">
                                <div className="img-box">
                                    {/* <Capsule texture={DiscountImg} directionY={0.01} />
                                    <Capsule texture={DiscountImg1} directionY={-0.01} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>      

            

                {
                    prodType.map((data, index) => {
                        const filteredProducts = prod.filter(
                            (elem) =>
                                elem.productType === data.productType &&
                                (elem.productTitle.toLowerCase().includes(search.toLowerCase()) ||
                                    elem.productType.toLowerCase().includes(search.toLowerCase()))
                        );
                        if (filteredProducts.length === 0) {
                            return null;
                        }
                        return (
                            <div key={index} className="container mb-3">
                                <h3 className="text-uppercase">
                                    {data.productType}
                                </h3>
                                <div className="d-flex" style={{
                                    flexWrap:'wrap'}}>
                                    {filteredProducts.map((item, medIndex) => (
                                        <div
                                            key={medIndex}
                                            className="col-12 col-md-6 col-lg-3"
                                            style={{ objectFit: "fill" }}
                                        >
                                            <div className="health_carousel-container">
                                                <Product medProduct={item} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })
                }
            
            {/* {
                prodType !== []
                    ?
                    prodType.map((data,index) => {
                        return (<div key={index} className='row mb-3'> 
                            <h3 style={{ marginLeft: '15px' }} className='text-uppercase'>{data.productType}</h3> <hr />
                            {
                                prod !== []
                                    ?
                                    prod.filter((elem) => (elem.productType === data.productType) && ((elem.productTitle.toLowerCase().includes(search.toLocaleLowerCase())) || (elem.productType.toLowerCase().includes(search.toLocaleLowerCase())))).map((item, medIndex) => {
                                        return (
                                            
                                            
                                            <div key={medIndex} className='col-12 col-md-6 col-lg-3' style={{ objectFit: 'fill' }} >

                                            <div className='health_carousel-container'>
                                                <Product medProduct={item} />
                                            </div>


                                        </div>)
                                    })
                                    :''
                            }

                        
                        
                        
                        </div>                        
                        )
                    })
                    : <div>no data</div> 


            } */}

        </>
    )
}
